import type { ProductRankingData,ProductRankingItem } from '../types';

const GOOGLE_SHEETS_URL =
  'https://docs.google.com/spreadsheets/d/1otntFF3G7wUyvH2tkqHzQTXXFNPPOHNYSWRM-9IaDCw/export?format=csv&gid=0';

export const productRankingService = {
  async fetchFromGoogleSheets(): Promise<ProductRankingData> {
    try {
      const response = await fetch(GOOGLE_SHEETS_URL);
      const csvText = await response.text();

      // Parse CSV to JSON
      const lines = csvText.split('\n');
      const headers = lines[0]
        .split(',')
        .map((header) => header.trim().replace(/"/g, ''));

      const products: ProductRankingItem[] = lines
        .slice(1)
        .filter((line) => line.trim())
        .map((line) => {
          const values = this.parseCSVLine(line);
          const product: any = {};

          headers.forEach((header, index) => {
            const value = values[index]?.trim().replace(/"/g, '') || '';

            // Handle specific field types
            switch (header) {
              case 'position':
              case 'reviewCount':
              case 'currentRank':
                product[header] = parseInt(value) || 0;
                break;
              case 'isTop30':
              case 'isOutOf100':
                product[header] = value.toLowerCase() === 'true';
                break;
              case 'rankChangeHistory[0].date':
              case 'rankChangeHistory[0].previousRank':
              case 'rankChangeHistory[0].currentRank':
              case 'rankChangeHistory[0].rankChange':
              case 'rankChangeHistory[0].scrapedAt': {
                if (!product.rankChangeHistory) {
                  product.rankChangeHistory = [{}];
                }
                const key = header.split('.')[1];
                product.rankChangeHistory[0][key] = value;
                break;
              }
              default:
                product[header] = value;
            }
          });

          return product as ProductRankingItem;
        });

      return { products };
    } catch (error) {
      console.error('Error fetching from Google Sheets:', error);
      throw new Error('Failed to fetch data from Google Sheets');
    }
  },

  parseCSVLine(line: string): string[] {
    const result = [];
    let current = '';
    let inQuotes = false;

    for (let i = 0; i < line.length; i++) {
      const char = line[i];

      if (char === '"') {
        inQuotes = !inQuotes;
      } else if (char === ',' && !inQuotes) {
        result.push(current);
        current = '';
      } else {
        current += char;
      }
    }

    result.push(current);
    return result;
  },
};
